function Close() {
  return (
    <div className="close-container">
      <div className="leftright"></div>
      <div className="rightleft"></div>
      {/* <label className="close">close</label> */}
    </div>
  );
}

export default Close;
